import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageview, trackEvent } from '../utils/analytics.js';

/**
 * Hook personnalisé pour suivre automatiquement les vues de pages et les changements d'onglets
 *
 * @param {Object} options - Options de configuration
 * @param {Object} options.currentMember - Le membre connecté (facultatif)
 * @param {Object} options.currentFamily - La famille connectée (facultatif)
 */
export default function useAnalytics(options = {}) {
  const location = useLocation();
  const { pathname } = location;
  const { currentMember, currentFamily } = options;

  // Suivi des changements de pages (sans le hash)
  useEffect(() => {
    let props = {};

    // Ajouter les infos d'utilisateur si disponibles
    if (currentMember) {
      props = {
        ...props,
        member: currentMember,
      };
    }

    if (currentFamily) {
      props = {
        ...props,
        family: currentFamily.invite_code
      };
    }

    try {
      trackPageview({
        url: pathname,
      }, { props });
    } catch (error) {}
  }, [pathname, currentMember, currentFamily]);

  const track = (eventName, props) => {

    if (currentMember) {
      props = {
        ...props,
        member: currentMember,
      };
    }

    if (currentFamily) {
      props = {
        ...props,
        family: currentFamily.invite_code
      };
    }

    try {
      trackEvent(eventName, { props });
    } catch (error) {}
  };

  // Pas besoin de retourner quoi que ce soit, le hook s'occupe du tracking en arrière-plan
  return { track };
}